<template>
	<div class="modal" id="invoiceModal" ref="invoiceModal">
  		<div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    		  <div class="modal-content">
              <div class="modal-body">
                  <div
                      class="row d-flex justify-content center align-items-center mt-2"
                      v-if="!pageCount || pageCount < 1"
                  >
                      <div class="col-12 text-center">
                          <loading-spinner/>
                      </div>
                  </div>
                  <div v-if="invoiceUrl">
                      <pdf
                          :src="invoiceUrl"
                          :page="currentPage"
                          @num-pages="pageCount = $event"
                          @page-loaded="currentPage = $event"
                      >
                      </pdf>
                  </div>
              </div>
              <div class="modal-footer">
                  <div class="text-center">
                      <button
                          class="btn btn-success"
                          @click.prevent="download()"
                      >
                          Letöltés
                      </button>
                      <button
                          class="btn btn-primary"
                          @click.prevent="currentPage -= 1"
                          :disabled="currentPage == 1"
                      >
                          Előző oldal
                      </button>
                      <span class="pl-1 pr-1 h5">
                          [ {{ currentPage}} / {{ pageCount}} ]
                      </span>
                      <button
                          class="btn btn-primary"
                          @click.prevent="currentPage += 1"
                          :disabled="currentPage == pageCount || !pageCount"
                      >
                          Következő oldal
                      </button>
                  </div>
                  <button class="btn btn-secondary" @click.prevent="close">
                      Bezárás
                  </button>
              </div>
    		  </div>
  		</div>
	</div>
</template>
<script type="text/javascript">
import pdf from 'vue-pdf/src/vuePdfNoSss'
export default {
    props: ['invoice'],

    components: {
        pdf
    },

    data() {
        return {
            currentPage: 1,
            pageCount: 0,
            invoiceUrl: null
        }
    },

    mounted() {
        $('#invoiceModal').modal('show')
        let user = this.$store.getters.user ? this.$store.getters.user.loginnev : null
        let token = this.$store.getters.token ? this.$store.getters.token : null
        let szolg = this.invoice.szla_szolg
        let id = this.invoice.invoice_id
        this.invoiceUrl = `${this.baseURL}/orders/invoice/${szolg}/${id}?user=${user}&token=${token}`
    },

    methods: {
		    close() {
    		    $('#invoiceModal').modal('hide')
    		    this.$emit('close')
		    },

        download() {
            this.$Progress.start()
            this.isLoading = true
            this.req.get(this.invoiceUrl, { responseType: 'blob' } )
              .then(res => {
                  const url = window.URL.createObjectURL(new Blob([res.data]))
                  const link = document.createElement('a')
                  link.href = url
                  link.setAttribute('download', `${this.invoice.invoice_number}.pdf`)
                  document.body.appendChild(link)
                  link.click()
                  this.$Progress.finish()
                  this.isLoading = false
              })
              .catch(err => {
                  toastr.error(err.response.data.text || 'hiba a letöltésben')
                  this.$Progress.fail()
                  this.isLoading = false
              })
        },

        err(e) {
            console.error(e)
        }
    }
}
</script>
<style type="text/css" scoped>
.spinner-border {
    width: 3rem;
    height: 3rem;
}
</style>


// WEBPACK FOOTER //
// src/components/invoice.vue